import { render, staticRenderFns } from "./HeroSlider.vue?vue&type=template&id=01b01e1e&scoped=true&"
import script from "./HeroSlider.vue?vue&type=script&lang=js&"
export * from "./HeroSlider.vue?vue&type=script&lang=js&"
import style0 from "./HeroSlider.vue?vue&type=style&index=0&id=01b01e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b01e1e",
  null
  
)

export default component.exports